import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installer-page',
  templateUrl: './installer-page.component.html',
  styleUrls: ['./installer-page.component.scss']
})
export class InstallerPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
